<template>
  <router-view name="seoUpdate" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "SeoUpdate",
};
</script>
